import React, { useEffect, useState } from "react";
import { CreateButton, HeaderMain, HeaderWrapper, LangSwitch, LangSwitchWrapper, Logo, MobileButton, Switchers, ThemeSwitch } from "./Header.styled";
import logo from "../../assets/img/header-logo.svg";
import moon from "../../assets/img/moon.svg";
import lightMoon from "../../assets/img/lightMoon.svg";
import sun from "../../assets/img/sun.svg";
import { HeaderMenu } from "./HeaderMenu/HeaderMenu";
import { Search } from "./Search/Search";
import { CreateDropdown } from "./CreateDropdown/CreateDropdown";
import { MobileMenu } from "./MobileMenu/MobileMenu";
import { useDispatch, useSelector } from "react-redux";
import { changeLang, changeTheme } from "../../store/app/appSlice";
import { useLocation } from "react-router-dom";

export const Header = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showLangSwitch, setShowLangSwitch] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [scroll, setScroll] = useState(0);
  const theme = useSelector((state) => state.app.theme);
  const lang = useSelector((state) => state.app.lang);
  const dispatch = useDispatch();
  const location = useLocation();

  let whiteText = location.pathname.includes("/collections/") || location.pathname.includes("/creators/");

  const toggleTheme = () => {
    if (theme === "dark") {
      dispatch(changeTheme("light"));
    } else dispatch(changeTheme("dark"));
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <HeaderWrapper whiteText={scroll < 100 && whiteText ? true : null}>
      <div className='container'>
        <HeaderMain onMouseLeave={() => setShowDropdown(false)}>
          <Logo to='/'>
            <img src={logo} alt='logo' />
          </Logo>
          <HeaderMenu />
          <Search />
          <CreateButton onMouseEnter={() => setShowDropdown(true)}>
            Create
            {showDropdown && <CreateDropdown />}
          </CreateButton>
          <Switchers>
            <LangSwitchWrapper>
              <LangSwitch
                whiteText={whiteText}
                showLangSwitch={showLangSwitch}
                onMouseEnter={() => setShowLangSwitch(true)}
                onMouseLeave={() => setShowLangSwitch(false)}>
                <span className={lang != "EN" && "hidden"} onClick={() => (dispatch(changeLang("EN")), setShowLangSwitch(false))}>
                  EN
                </span>
                <span className={lang != "Укр" && "hidden"} onClick={() => (dispatch(changeLang("Укр")), setShowLangSwitch(false))}>
                  Укр
                </span>
                <span className={lang != "Рус" && "hidden"} onClick={() => (dispatch(changeLang("Рус")), setShowLangSwitch(false))}>
                  Рус
                </span>
              </LangSwitch>
            </LangSwitchWrapper>
            <ThemeSwitch onClick={() => toggleTheme()} whiteText={whiteText}>
              <img src={theme === "dark" ? sun : whiteText && scroll < 100 ? lightMoon : moon} alt='theme switch' />
            </ThemeSwitch>
            <MobileButton openMenu={openMenu} onClick={() => setOpenMenu(!openMenu)} whiteText={scroll < 100 && whiteText ? true : null}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </MobileButton>
          </Switchers>
        </HeaderMain>
      </div>
      <MobileMenu openMenu={openMenu} closeMenu={() => setOpenMenu(false)} />
    </HeaderWrapper>
  );
};
